(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(52410);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EmotionSelector; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14924);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87066);
/* harmony import */ var common_interfaces_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21694);
/* harmony import */ var store_timeline__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12800);
/* harmony import */ var components_common_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37975);
/* harmony import */ var _EmotionSelector_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53811);
/* harmony import */ var _EmotionSelector_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_EmotionSelector_module_scss__WEBPACK_IMPORTED_MODULE_8__);










function EmotionSelector() {
    var currentUser = (0,store_timeline__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(function(state) {
        return state.currentUser;
    });
    var refetchProfile = (0,store_timeline__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(function(state) {
        return state.refetchProfile;
    });
    var handleUpdateEmotion = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(emotion) {
            return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return axios__WEBPACK_IMPORTED_MODULE_7__/* ["default"].post */ .Z.post("/profiles/emotions", {
                            emotion: emotion
                        });
                    case 2:
                        refetchProfile();
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleUpdateEmotion(emotion) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDeleteEmotion = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return axios__WEBPACK_IMPORTED_MODULE_7__/* ["default"]["delete"] */ .Z["delete"]("/profiles/emotions");
                    case 2:
                        refetchProfile();
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleDeleteEmotion() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (_EmotionSelector_module_scss__WEBPACK_IMPORTED_MODULE_8___default().selectEmotionMenu),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (_EmotionSelector_module_scss__WEBPACK_IMPORTED_MODULE_8___default().emotions),
                children: Object.values(common_interfaces_api__WEBPACK_IMPORTED_MODULE_3__/* .Emotion */ .T1).map(function(emotion) {
                    var isActive = emotion === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.emotion);
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_EmotionSelector_module_scss__WEBPACK_IMPORTED_MODULE_8___default().emotion), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (_EmotionSelector_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active), isActive)),
                        onClick: function() {
                            return handleUpdateEmotion(emotion);
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                name: "emotion-sel-".concat(emotion),
                                width: 24,
                                height: 24
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (_EmotionSelector_module_scss__WEBPACK_IMPORTED_MODULE_8___default().highlight)
                            })
                        ]
                    }, emotion);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (_EmotionSelector_module_scss__WEBPACK_IMPORTED_MODULE_8___default().delEmotionBtn),
                onClick: function() {
                    return handleDeleteEmotion();
                },
                children: "ムード絵文字を消す"
            })
        ]
    });
};


/***/ }),

/***/ 74688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PopperWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_ClickAwayListener__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52795);
/* harmony import */ var _material_ui_core_Popper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84872);
/* harmony import */ var _PopperWrapper_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10842);
/* harmony import */ var _PopperWrapper_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_PopperWrapper_module_scss__WEBPACK_IMPORTED_MODULE_3__);





function PopperWrapper(param) {
    var buttonEl = param.buttonEl, contentEl = param.contentEl, anchorEl = param.anchorEl, setAnchorEl = param.setAnchorEl, _click = param.click, click = _click === void 0 ? true : _click, _hover = param.hover, hover = _hover === void 0 ? false : _hover, _showArrow = param.showArrow, showArrow = _showArrow === void 0 ? true : _showArrow, _disablePortal = param.disablePortal, disablePortal = _disablePortal === void 0 ? false : _disablePortal, _verticalOffset = param.verticalOffset, verticalOffset = _verticalOffset === void 0 ? 10 : _verticalOffset, _horizontalOffset = param.horizontalOffset, horizontalOffset = _horizontalOffset === void 0 ? 20 : _horizontalOffset, id = param.id;
    var handleClick = function(event) {
        event.preventDefault();
        event.stopPropagation();
        if (!anchorEl) {
            setAnchorEl(event.currentTarget);
        } else {
            setAnchorEl(null);
        }
    };
    var handleMouseEnter = function(event) {
        if (!anchorEl) {
            setAnchorEl(event.currentTarget);
        }
    };
    var handleMouseLeave = function() {
        if (anchorEl) {
            setAnchorEl(null);
        }
    };
    var handleClickAway = function() {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    var renderBtn = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(buttonEl, {
        onClick: click ? handleClick : undefined,
        onMouseEnter: hover ? handleMouseEnter : undefined,
        "data-is-open": open
    });
    var arrowOffset = 15;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ClickAwayListener__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        onClickAway: handleClickAway,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_PopperWrapper_module_scss__WEBPACK_IMPORTED_MODULE_3___default().popperWrapper),
            children: [
                renderBtn,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Popper__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    id: id,
                    open: open,
                    anchorEl: anchorEl,
                    modifiers: {
                        offset: {
                            enabled: true,
                            offset: "-".concat(horizontalOffset, ", ").concat(verticalOffset)
                        }
                    },
                    disablePortal: disablePortal,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_PopperWrapper_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container),
                        onMouseLeave: hover ? handleMouseLeave : undefined,
                        children: [
                            contentEl,
                            showArrow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_PopperWrapper_module_scss__WEBPACK_IMPORTED_MODULE_3___default().arrow),
                                style: {
                                    left: "calc(50% + ".concat(arrowOffset, "px)")
                                }
                            })
                        ]
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 52410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ HomeTimeline; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./store/timeline.ts
var timeline = __webpack_require__(12800);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(87066);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/common/Icon/index.tsx
var Icon = __webpack_require__(37975);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./store/global.ts
var global = __webpack_require__(8405);
// EXTERNAL MODULE: ./components/common/ImportantMessagesSection/ImportantMessagesSection.module.scss
var ImportantMessagesSection_module = __webpack_require__(55812);
var ImportantMessagesSection_module_default = /*#__PURE__*/__webpack_require__.n(ImportantMessagesSection_module);
;// CONCATENATED MODULE: ./components/common/ImportantMessagesSection/index.tsx










var ImportantMessagesSection = function() {
    var isAuthInit = (0,global/* default */.Z)(function(state) {
        return state.isAuthInit;
    });
    var currentAuth = (0,global/* default */.Z)(function(state) {
        return state.currentAuth;
    });
    var ref = (0,es.useQuery)("getBanners", (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return axios/* default.get */.Z.get("/profiles/system/banners");
                case 2:
                    return _ctx.abrupt("return", _ctx.sent.data);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        refetchOnWindowFocus: false,
        enabled: isAuthInit && !!currentAuth,
        staleTime: 15 * 60 * 1000,
        cacheTime: 15 * 60 * 1000
    }), data = ref.data, refetch = ref.refetch;
    var ref1 = (0,es.useMutation)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var banner, _accept, accept, acceptParam;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        banner = param.banner, _accept = param.accept, accept = _accept === void 0 ? false : _accept;
                        acceptParam = accept ? "?accept=true" : "";
                        return _ctx.abrupt("return", axios/* default.post */.Z.post("/profiles/system/banners/".concat(banner.id, "/confirms?").concat(acceptParam), {}));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSuccess: function() {
            void refetch();
        }
    }), confirmBanner = ref1.mutate;
    var banners = ((data === null || data === void 0 ? void 0 : data.data) || []).filter(function(banner) {
        return [
            "general_notification",
            "agreement_notification"
        ].includes(banner.type);
    });
    if (!currentAuth || banners.length === 0) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ImportantMessagesSection_module_default()).messages,
        children: banners && banners.map(function(banner) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((ImportantMessagesSection_module_default()).message, (0,_define_property/* default */.Z)({}, (ImportantMessagesSection_module_default())[banner.severity], !!banner.severity)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ImportantMessagesSection_module_default()).close,
                        onClick: function() {
                            return confirmBanner({
                                banner: banner
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "close-red",
                            width: 16,
                            height: 16
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ImportantMessagesSection_module_default()).content,
                        dangerouslySetInnerHTML: {
                            __html: bannerContent(banner)
                        }
                    })
                ]
            }, "banner-".concat(banner.id));
        })
    });
};
var bannerContent = function(banner) {
    var textContent = banner.text;
    if (!banner.url) return textContent;
    var start = textContent.indexOf("[");
    var end = textContent.indexOf("]");
    var linkText = textContent.substring(start + 1, end);
    return textContent.replace("[".concat(linkText, "]"), '<a target="_blank" href="'.concat(banner.url, '">').concat(linkText, "</a>"));
};
/* harmony default export */ var common_ImportantMessagesSection = (ImportantMessagesSection);

// EXTERNAL MODULE: ./components/modules/TimelinePage/TimelinePage.module.scss
var TimelinePage_module = __webpack_require__(20864);
var TimelinePage_module_default = /*#__PURE__*/__webpack_require__.n(TimelinePage_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/molecules/RandomBanner/index.tsx + 7 modules
var RandomBanner = __webpack_require__(81618);
// EXTERNAL MODULE: ./common/utils/banner.ts
var banner = __webpack_require__(38285);
// EXTERNAL MODULE: ./service/user.ts
var service_user = __webpack_require__(8193);
// EXTERNAL MODULE: ./components/common/AnimeAlarmBanner/index.tsx
var AnimeAlarmBanner = __webpack_require__(85222);
// EXTERNAL MODULE: ./common/interfaces/api.ts
var api = __webpack_require__(21694);
// EXTERNAL MODULE: ./config/api.ts
var config_api = __webpack_require__(92922);
;// CONCATENATED MODULE: ./service/system.ts




var getSystemSettings = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(abTestKey) {
        var ref, abTestParam;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    abTestParam = abTestKey ? "?ab_keys=".concat(abTestKey) : "";
                    _ctx.next = 4;
                    return (0,axios/* default */.Z)({
                        method: "GET",
                        baseURL: config_api/* default.BACKEND_BASE_URL.replace */.Z.BACKEND_BASE_URL.replace("/v1", ""),
                        url: "/system/versions".concat(abTestParam)
                    });
                case 4:
                    _ctx.t1 = ref = _ctx.sent;
                    _ctx.t0 = _ctx.t1 === null;
                    if (_ctx.t0) {
                        _ctx.next = 8;
                        break;
                    }
                    _ctx.t0 = ref === void 0;
                case 8:
                    if (!_ctx.t0) {
                        _ctx.next = 12;
                        break;
                    }
                    _ctx.t2 = void 0;
                    _ctx.next = 13;
                    break;
                case 12:
                    _ctx.t2 = ref.data;
                case 13:
                    return _ctx.abrupt("return", _ctx.t2);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSystemSettings(abTestKey) {
        return _ref.apply(this, arguments);
    };
}();
var getInitTimelineData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return axios/* default.get */.Z.get("/feeds/home-timeline", {
                        params: {
                            page: 1
                        }
                    });
                case 3:
                    _ctx.t1 = ref = _ctx.sent;
                    _ctx.t0 = _ctx.t1 === null;
                    if (_ctx.t0) {
                        _ctx.next = 7;
                        break;
                    }
                    _ctx.t0 = ref === void 0;
                case 7:
                    if (!_ctx.t0) {
                        _ctx.next = 11;
                        break;
                    }
                    _ctx.t2 = void 0;
                    _ctx.next = 12;
                    break;
                case 11:
                    _ctx.t2 = ref.data;
                case 12:
                    return _ctx.abrupt("return", _ctx.t2);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getInitTimelineData() {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./components/TimelineSection/index.tsx
var TimelineSection = __webpack_require__(32954);
// EXTERNAL MODULE: ./components/modules/TimelinePage/RecommendTabSection/RecommendTabSection.module.scss
var RecommendTabSection_module = __webpack_require__(79099);
var RecommendTabSection_module_default = /*#__PURE__*/__webpack_require__.n(RecommendTabSection_module);
// EXTERNAL MODULE: ./components/common/PreloadContentLoader/index.tsx + 1 modules
var PreloadContentLoader = __webpack_require__(60782);
// EXTERNAL MODULE: ./components/Post/index.tsx
var Post = __webpack_require__(53704);
// EXTERNAL MODULE: ./components/CreatePostBox/index.tsx
var CreatePostBox = __webpack_require__(87824);
// EXTERNAL MODULE: ./common/utils/index.ts + 1 modules
var utils = __webpack_require__(22467);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./components/modules/TimelinePage/HomeRecommendCreatorsList/HomeRecommendCreatorsList.module.scss
var HomeRecommendCreatorsList_module = __webpack_require__(28739);
var HomeRecommendCreatorsList_module_default = /*#__PURE__*/__webpack_require__.n(HomeRecommendCreatorsList_module);
// EXTERNAL MODULE: ./components/templates/MainTemplate/index.tsx + 7 modules
var MainTemplate = __webpack_require__(89321);
// EXTERNAL MODULE: ./components/common/LinkButton/index.tsx
var LinkButton = __webpack_require__(22396);
// EXTERNAL MODULE: ./components/common/BadgeIcon/index.tsx
var BadgeIcon = __webpack_require__(85650);
// EXTERNAL MODULE: ./components/common/RoundIcon/index.tsx
var RoundIcon = __webpack_require__(10184);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/modules/TimelinePage/HomeRecommendCreatorsList/index.tsx













var HomeRecommendCreatorsList = function() {
    var ref = (0,react.useContext)(MainTemplate/* MainTemplateContext */.Q), spotlightUsers = ref.spotlightUsers, isFetchedSpotlightUsers = ref.isFetchedSpotlightUsers;
    var ref1 = (0,react.useState)(true), isShowingLimit = ref1[0], setIsShowingLimit = ref1[1];
    var users = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)(spotlightUsers || []).reverse().slice(0, 10);
    }, [
        spotlightUsers
    ]);
    if (!isFetchedSpotlightUsers || !users || (users === null || users === void 0 ? void 0 : users.length) === 0) return null;
    var showingLimitButton = users && (users === null || users === void 0 ? void 0 : users.length) > 5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (HomeRecommendCreatorsList_module_default()).homeRecommendCreatorsList,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HomeRecommendCreatorsList_module_default()).title,
                children: "おすすめクリエイター"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (HomeRecommendCreatorsList_module_default()).creatorsList,
                children: [
                    (users || []).map(function(user, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CreatorItem, {
                            user: user,
                            isHiding: isShowingLimit && index > 4
                        }, "".concat(user.id, "-").concat(index));
                    }),
                    showingLimitButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HomeRecommendCreatorsList_module_default()).readMoreBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* default */.Z, {
                            text: isShowingLimit ? "もっと見る" : "一部表示",
                            nonUnderline: true,
                            fontSize: 14,
                            onClick: function() {
                                setIsShowingLimit(function(prev) {
                                    return !prev;
                                });
                            }
                        })
                    })
                ]
            })
        ]
    });
};
var CreatorItem = function(param) {
    var user = param.user, isHiding = param.isHiding;
    var currentAuth = (0,global/* default */.Z)(function(state) {
        return state.currentAuth;
    });
    var showLogin = (0,global/* default */.Z)(function(state) {
        return state.showLogin;
    });
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    // Follow button
    // use local state to make sure user's action is immediate
    var ref = (0,react.useState)(user.is_followed), isFollowed = ref[0], setIsFollowed = ref[1];
    var handleFollowClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(event) {
            var action;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        event.preventDefault();
                        if (user) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        if (!currentAuth) {
                            _ctx.next = 16;
                            break;
                        }
                        _ctx.prev = 4;
                        action = isFollowed ? "unfollow" : "follow";
                        if (isFollowed) {
                            setIsFollowed(false);
                        } else {
                            setIsFollowed(true);
                        }
                        _ctx.next = 9;
                        return (0,service_user/* handleFollowAction */.eW)(user.id, action);
                    case 9:
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](4);
                        setSnackbarMessage({
                            type: "error",
                            text: "エラーが発生しました。"
                        });
                    case 14:
                        _ctx.next = 17;
                        break;
                    case 16:
                        {
                            showLogin({});
                        }
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    11
                ]
            ]);
        }));
        return function handleFollowClick(event) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/".concat(user.username),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: (HomeRecommendCreatorsList_module_default()).creatorItem,
            style: isHiding ? {
                display: "none"
            } : {},
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (HomeRecommendCreatorsList_module_default()).creatorInfoWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HomeRecommendCreatorsList_module_default()).creatorAvatar,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundIcon/* default */.Z, {
                                user: user,
                                width: 48,
                                height: 48,
                                hasRing: true,
                                enableClick: false,
                                emotion: null,
                                showLiveFlag: false
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (HomeRecommendCreatorsList_module_default()).creatorInfo,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (HomeRecommendCreatorsList_module_default()).userNameWrapper,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HomeRecommendCreatorsList_module_default()).userName,
                                            title: user.name,
                                            children: user.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HomeRecommendCreatorsList_module_default()).badge,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeIcon/* default */.Z, {
                                                badge: user.badge,
                                                width: 36,
                                                height: 36
                                            })
                                        })
                                    ]
                                }),
                                user.bio && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (HomeRecommendCreatorsList_module_default()).userBio,
                                    children: user.bio
                                })
                            ]
                        })
                    ]
                }),
                !isFollowed && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: (HomeRecommendCreatorsList_module_default()).followBtn,
                    onClick: function(e) {
                        return handleFollowClick(e);
                    },
                    children: "フォロー"
                })
            ]
        })
    });
};
/* harmony default export */ var TimelinePage_HomeRecommendCreatorsList = (HomeRecommendCreatorsList);

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(21190);
// EXTERNAL MODULE: ./components/common/InfiniteScroll/index.tsx
var InfiniteScroll = __webpack_require__(68330);
// EXTERNAL MODULE: ./components/modules/TimelinePage/SubscribingSection/SubscribingSection.module.scss
var SubscribingSection_module = __webpack_require__(32634);
var SubscribingSection_module_default = /*#__PURE__*/__webpack_require__.n(SubscribingSection_module);
// EXTERNAL MODULE: ./common/utils/hooks/useDidMount.ts
var useDidMount = __webpack_require__(86177);
;// CONCATENATED MODULE: ./components/modules/TimelinePage/SubscribingSection/index.tsx
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ 













var SubscribingSection = function() {
    var shouldRefetchPosts = (0,timeline/* default */.ZP)(function(state) {
        return state.shouldRefetchPosts;
    });
    var isAuthInit = (0,global/* default */.Z)(function(state) {
        return state.isAuthInit;
    });
    var currentAuth = (0,global/* default */.Z)(function(state) {
        return state.currentAuth;
    });
    var mounted = (0,useDidMount/* useMountedDelay */._)();
    var ref = (0,es.useInfiniteQuery)("getSubscribingPosts", function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var _pageParam, pageParam, ref, ref1, ref2, paramsStr;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? {
                            page: 3,
                            lastPostId: ""
                        } : _pageParam;
                        ;
                        if (!(!isAuthInit || !mounted)) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject());
                    case 4:
                        paramsStr = "?page=".concat(String(pageParam === null || pageParam === void 0 ? void 0 : pageParam.page), "&last_post_id=").concat(String(pageParam === null || pageParam === void 0 ? void 0 : pageParam.lastPostId));
                        _ctx.next = 7;
                        return axios/* default.get */.Z.get("/feeds/home-timeline".concat(paramsStr));
                    case 7:
                        _ctx.t1 = ref = _ctx.sent;
                        _ctx.t0 = _ctx.t1 === null;
                        if (_ctx.t0) {
                            _ctx.next = 11;
                            break;
                        }
                        _ctx.t0 = ref === void 0;
                    case 11:
                        if (!_ctx.t0) {
                            _ctx.next = 15;
                            break;
                        }
                        _ctx.t2 = void 0;
                        _ctx.next = 16;
                        break;
                    case 15:
                        _ctx.t2 = (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.sections[0];
                    case 16:
                        return _ctx.abrupt("return", _ctx.t2);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        getNextPageParam: function(lastPage, pages) {
            var posts = lastPage === null || lastPage === void 0 ? void 0 : lastPage.latest_posts;
            if (posts && posts.length > 0) {
                var ref;
                return {
                    page: pages.length + 3,
                    lastPostId: (ref = posts[posts.length - 1]) === null || ref === void 0 ? void 0 : ref.id
                };
            }
        },
        enabled: isAuthInit && !!currentAuth && mounted,
        refetchOnWindowFocus: false,
        staleTime: 15 * 60 * 1000,
        cacheTime: 15 * 60 * 1000
    }), isLoading = ref.isLoading, data = ref.data, fetchNextPage = ref.fetchNextPage, refetch = ref.refetch, isFetchingNextPage = ref.isFetchingNextPage;
    (0,react.useEffect)(function() {
        if (shouldRefetchPosts) {
            void refetch();
        }
    }, [
        shouldRefetchPosts,
        refetch
    ]);
    var pages = data === null || data === void 0 ? void 0 : data.pages;
    var posts = (0,react.useMemo)(function() {
        return pages ? pages.reduce(function(curr, page) {
            var posts = (page === null || page === void 0 ? void 0 : page.latest_posts) || [];
            return curr.concat(posts);
        }, []) : [];
    }, [
        pages
    ]);
    // Animation
    var ref1 = (0,react.useState)(false), doUseAnimation = ref1[0], setUseAnimation = ref1[1];
    // Prevent animation from playing on first load
    (0,react.useEffect)(function() {
        var timeout;
        if (!isLoading) {
            timeout = setTimeout(function() {
                return setUseAnimation(true);
            });
        }
        return function() {
            clearTimeout(timeout);
            setUseAnimation(false);
        };
    }, [
        isLoading
    ]);
    if (!currentAuth) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (posts.length === 0) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (SubscribingSection_module_default()).sectionWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScroll/* default */.Z, {
            fetchNextPage: fetchNextPage,
            isLoading: isFetchingNextPage,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                initial: false,
                children: posts.map(function(post, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Post/* default */.Z, {
                        post: post,
                        hasFollowBtn: true,
                        shouldAnimate: doUseAnimation,
                        parent: api/* PostParentKey.HomeRecommendPosts */.rO.HomeRecommendPosts
                    }, "".concat(post === null || post === void 0 ? void 0 : post.id, "-").concat(index));
                })
            })
        })
    });
};
/* harmony default export */ var TimelinePage_SubscribingSection = (SubscribingSection);

// EXTERNAL MODULE: ./common/utils/pp_tracking.ts
var pp_tracking = __webpack_require__(67027);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/modules/TimelinePage/RecommendTabSection/index.tsx








// import LiveUsers from '../LiveUsers';






var SymbolDataView = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3136), __webpack_require__.e(3854)]).then(__webpack_require__.bind(__webpack_require__, 33854));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33854)
            ];
        }
    },
    ssr: false
});
var RecommendTabSection = function(param) {
    var voteTabId = param.voteTabId, setVoteTabId = param.setVoteTabId;
    var isMobile = (0,utils/* useMediaQuery */.ac)("(max-width: 767px)");
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var ref = (0,react.useContext)(TimelinePageContext), isFetchedTimeline = ref.isFetchedTimeline, trendingPosts = ref.trendingPosts, symbolId = ref.symbolId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (RecommendTabSection_module_default()).recommendTabSection,
        children: [
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (RecommendTabSection_module_default()).createPost,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreatePostBox/* default */.Z, {})
            }),
            currentUser && symbolId && /*#__PURE__*/ (0,jsx_runtime.jsx)(SymbolDataView, {
                screenName: pp_tracking/* ScreenName.HomeTimeline */.CG.HomeTimeline,
                symbolId: symbolId,
                parentTabId: voteTabId,
                setParentTabId: setVoteTabId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (RecommendTabSection_module_default()).postsList,
                children: isFetchedTimeline ? (trendingPosts || []).map(function(post, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Post/* default */.Z, {
                        post: post,
                        parent: api/* PostParentKey.HomeRecommendPosts */.rO.HomeRecommendPosts,
                        hasFollowBtn: true
                    }, "".concat(post === null || post === void 0 ? void 0 : post.id, "-").concat(index));
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PreloadContentLoader/* PostsLoader */.DN, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelinePage_HomeRecommendCreatorsList, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelinePage_SubscribingSection, {})
        ]
    });
};
/* harmony default export */ var TimelinePage_RecommendTabSection = (RecommendTabSection);

// EXTERNAL MODULE: ./components/modules/TimelinePage/PostTopicsTabSection/PostTopicsTabSection.module.scss
var PostTopicsTabSection_module = __webpack_require__(61758);
var PostTopicsTabSection_module_default = /*#__PURE__*/__webpack_require__.n(PostTopicsTabSection_module);
// EXTERNAL MODULE: ./components/PostTopicSection/TopicSection.module.scss
var TopicSection_module = __webpack_require__(42814);
var TopicSection_module_default = /*#__PURE__*/__webpack_require__.n(TopicSection_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/PostTopicSection/index.tsx


















function PostTopicSection(param) {
    var topic = param.topic, className = param.className, sortType = param.sortType, setSortType = param.setSortType;
    var shouldRefetchPosts = (0,timeline/* default */.ZP)(function(state) {
        return state.shouldRefetchPosts;
    });
    var isAuthInit = (0,global/* default */.Z)(function(state) {
        return state.isAuthInit;
    });
    var mounted = (0,useDidMount/* useMountedDelay */._)();
    var router = (0,next_router.useRouter)();
    var order = router.query.order;
    (0,react.useEffect)(function() {
        setSortType(order === "latest" ? "latest" : "recommend");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        topic
    ]);
    var ref = (0,es.useInfiniteQuery)([
        "fetchPostTopicData",
        topic,
        sortType
    ], function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var _pageParam, pageParam, url;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 1 : _pageParam;
                        if (!(!isAuthInit || !topic || !mounted)) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject());
                    case 3:
                        url = "/feeds/domain_posts?domain_name=".concat(topic, "&page=").concat(pageParam, "&sort=").concat(sortType);
                        _ctx.next = 6;
                        return axios/* default.get */.Z.get(url);
                    case 6:
                        return _ctx.abrupt("return", _ctx.sent.data);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        getNextPageParam: function(lastPage, pages) {
            var ref;
            var posts = lastPage === null || lastPage === void 0 ? void 0 : (ref = lastPage.data) === null || ref === void 0 ? void 0 : ref.posts;
            if (posts && posts.length > 0) {
                return pages.length + 1;
            }
        },
        enabled: isAuthInit && !!topic && mounted,
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: 15 * 60 * 1000,
        cacheTime: 15 * 60 * 1000
    }), isLoading = ref.isLoading, data = ref.data, fetchNextPage = ref.fetchNextPage, isFetchingNextPage = ref.isFetchingNextPage, isFetched = ref.isFetched, refetch = ref.refetch;
    var pages = data === null || data === void 0 ? void 0 : data.pages;
    var posts = (0,react.useMemo)(function() {
        return pages ? pages.reduce(function(curr, page) {
            var ref;
            var posts = (ref = page.data) === null || ref === void 0 ? void 0 : ref.posts;
            return curr.concat(posts);
        }, []) : [];
    }, [
        pages
    ]);
    var postsRender = posts.map(function(post, index) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
            className: (TopicSection_module_default()).post,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Post/* default */.Z, {
                post: post,
                hasFollowBtn: true,
                parent: api/* PostParentKey.TopicPosts */.rO.TopicPosts
            })
        }, "".concat(post === null || post === void 0 ? void 0 : post.id, "-").concat(index));
    });
    var noPostPlaceholder;
    if (!isLoading && posts.length === 0) {
        noPostPlaceholder = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (TopicSection_module_default()).noPost,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                    name: "empty",
                    width: 96,
                    height: 96
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: "該当する投稿がありません"
                })
            ]
        });
    }
    (0,react.useEffect)(function() {
        if (shouldRefetchPosts) {
            void refetch();
        }
    }, [
        shouldRefetchPosts,
        refetch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((TopicSection_module_default()).container, className !== null && className !== void 0 ? className : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TopicSection_module_default()).titleWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: (TopicSection_module_default()).keyword,
                        children: [
                            topic,
                            "の最新ニュース"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (TopicSection_module_default()).sortSection,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: classnames_default()((TopicSection_module_default()).linkBtn, (0,_define_property/* default */.Z)({}, (TopicSection_module_default()).active, sortType === "recommend")),
                                style: isLoading ? {
                                    pointerEvents: "none"
                                } : {},
                                onClick: function() {
                                    setSortType("recommend");
                                    var isPostTopic = router.pathname.startsWith("/post_topics");
                                    if (!isPostTopic) return;
                                    void router.push({
                                        pathname: "/post_topics/".concat(topic)
                                    }, "/post_topics/".concat(topic), {
                                        shallow: true
                                    });
                                },
                                children: "おすすめ"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: classnames_default()((TopicSection_module_default()).linkBtn, (0,_define_property/* default */.Z)({}, (TopicSection_module_default()).active, sortType === "latest")),
                                style: isLoading ? {
                                    pointerEvents: "none"
                                } : {},
                                onClick: function() {
                                    setSortType("latest");
                                    var isPostTopic = router.pathname.startsWith("/post_topics");
                                    if (!isPostTopic) return;
                                    void router.push({
                                        pathname: "/post_topics/".concat(topic),
                                        query: {
                                            order: "latest"
                                        }
                                    }, "/post_topics/".concat(topic, "?order=latest"), {
                                        shallow: true
                                    });
                                },
                                children: "新着"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScroll/* default */.Z, {
                fetchNextPage: fetchNextPage,
                isLoading: isFetchingNextPage,
                children: isFetched ? postsRender : /*#__PURE__*/ (0,jsx_runtime.jsx)(PreloadContentLoader/* PostsLoader */.DN, {})
            }),
            noPostPlaceholder
        ]
    });
};

// EXTERNAL MODULE: ./components/modules/TimelinePage/InvestmentLevelsTabSection/InvestmentLevelsTabSection.module.scss
var InvestmentLevelsTabSection_module = __webpack_require__(82779);
var InvestmentLevelsTabSection_module_default = /*#__PURE__*/__webpack_require__.n(InvestmentLevelsTabSection_module);
// EXTERNAL MODULE: ./common/utils/investment_level.ts
var investment_level = __webpack_require__(47252);
;// CONCATENATED MODULE: ./components/modules/TimelinePage/InvestmentLevelsTabSection/index.tsx












var InvestmentLevelsTabSection = function() {
    var investmentLevels = (0,react.useContext)(TimelinePageContext).investmentLevels;
    var getNextPageParamPosts = (0,react.useCallback)(function(lastPage, pages) {
        var ref;
        var posts = lastPage === null || lastPage === void 0 ? void 0 : (ref = lastPage.data) === null || ref === void 0 ? void 0 : ref.posts;
        if (posts && posts.length > 0) {
            return pages.length + 1;
        }
    }, []);
    var ref = (0,_sliced_to_array/* default */.Z)((0,timeline/* default */.ZP)(function(state) {
        return [
            state.investmentLevelId,
            state.setInvestmentLevelId, 
        ];
    }), 2), investmentLevelId = ref[0], setInvestmentLevelId = ref[1];
    var showingInvestmentLevels = (0,react.useMemo)(function() {
        return [
            {
                id: investment_level/* ALL_LV_ID */.g,
                name: "全て"
            }, 
        ].concat((0,_to_consumable_array/* default */.Z)(((investmentLevels === null || investmentLevels === void 0 ? void 0 : investmentLevels.length) > 0 ? investmentLevels : investment_level/* DEFAULT_INVESTMENT_LEVELS */.z).map(function(level) {
            return {
                id: level.id,
                name: String(level.name)
            };
        })));
    }, [
        investmentLevels
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (InvestmentLevelsTabSection_module_default()).investmentLevelsTabSection,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (InvestmentLevelsTabSection_module_default()).sectionHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (InvestmentLevelsTabSection_module_default()).title,
                        children: "投資レベル"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (InvestmentLevelsTabSection_module_default()).investmentLevelsList,
                        children: showingInvestmentLevels.map(function(investmentLevel, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((InvestmentLevelsTabSection_module_default()).investmentLevel, (0,_define_property/* default */.Z)({}, (InvestmentLevelsTabSection_module_default()).active, investmentLevelId === String(investmentLevel.id))),
                                onClick: function() {
                                    return setInvestmentLevelId(String(investmentLevel.id));
                                },
                                children: investmentLevel.name
                            }, "".concat(investmentLevel.id, "-").concat(index));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (InvestmentLevelsTabSection_module_default()).postsList,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineSection/* default */.Z, {
                    apiUrl: "/feeds/investment_levels",
                    queryKey: [
                        api/* PostParentKey.InvestmentLevelPosts */.rO.InvestmentLevelPosts,
                        investmentLevelId.toString(), 
                    ],
                    queryParamKey: "page",
                    getNextPageParam: getNextPageParamPosts,
                    defaultPageParam: 1,
                    subQuery: investmentLevelId !== investment_level/* ALL_LV_ID */.g && {
                        key: "level_id",
                        value: investmentLevelId.toString()
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var TimelinePage_InvestmentLevelsTabSection = (InvestmentLevelsTabSection);

;// CONCATENATED MODULE: ./components/modules/TimelinePage/PostTopicsTabSection/index.tsx













var PostTopicsTabSection = function() {
    var postTopics = (0,react.useContext)(TimelinePageContext).postTopics;
    var ref = (0,_sliced_to_array/* default */.Z)((0,timeline/* default */.ZP)(function(state) {
        return [
            state.currentPostTopicName,
            state.setCurrentPostTopicName, 
        ];
    }), 2), currentPostTopicName = ref[0], setCurrentPostTopicName = ref[1];
    var isInvestmentLevel = currentPostTopicName === timeline/* INVESTMENT_TAB_NAME */.cj;
    var isMobile = (0,utils/* useMediaQuery */.ac)("(max-width: 767px)");
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,timeline/* default */.ZP)(function(state) {
        return [
            state.sortType,
            state.setSortType, 
        ];
    }), 2), sortType = ref1[0], setSortType = ref1[1];
    (0,react.useEffect)(function() {
        var ref;
        if (!currentPostTopicName && (postTopics === null || postTopics === void 0 ? void 0 : (ref = postTopics[0]) === null || ref === void 0 ? void 0 : ref.name)) {
            var ref1;
            setCurrentPostTopicName(postTopics === null || postTopics === void 0 ? void 0 : (ref1 = postTopics[0]) === null || ref1 === void 0 ? void 0 : ref1.name);
        }
    }, [
        currentPostTopicName,
        postTopics,
        setCurrentPostTopicName
    ]);
    var topicsRef = (0,react.useRef)();
    var scrollShowMore = function(offset) {
        if (topicsRef.current) {
            topicsRef.current.scrollLeft += offset;
        }
    };
    if (!currentPostTopicName) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (PostTopicsTabSection_module_default()).postTopicsTabSection,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PostTopicsTabSection_module_default()).topicsListWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (PostTopicsTabSection_module_default()).topicsList,
                    ref: topicsRef,
                    children: [
                        postTopics.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (PostTopicsTabSection_module_default()).backBtn,
                            onClick: function() {
                                scrollShowMore(-80);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* ForwardIcon */.jc, {
                                width: 24,
                                height: 24,
                                color: "#727272"
                            })
                        }),
                        postTopics.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (PostTopicsTabSection_module_default()).nextBtn,
                            onClick: function() {
                                scrollShowMore(80);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* ForwardIcon */.jc, {
                                width: 24,
                                height: 24,
                                color: "#727272"
                            })
                        }),
                        postTopics.map(function(topic, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((PostTopicsTabSection_module_default()).topic, (0,_define_property/* default */.Z)({}, (PostTopicsTabSection_module_default()).active, currentPostTopicName === topic.name)),
                                onClick: function() {
                                    setCurrentPostTopicName(topic.name);
                                    setSortType("recommend");
                                },
                                children: topic.name
                            }, "".concat(topic.id, "-").concat(index));
                        })
                    ]
                })
            }),
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PostTopicsTabSection_module_default()).createPost,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreatePostBox/* default */.Z, {})
            }),
            isInvestmentLevel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelinePage_InvestmentLevelsTabSection, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PostTopicSection, {
                topic: currentPostTopicName,
                className: (PostTopicsTabSection_module_default()).postsTopicList,
                sortType: sortType,
                setSortType: setSortType
            })
        ]
    });
};
/* harmony default export */ var TimelinePage_PostTopicsTabSection = (PostTopicsTabSection);

// EXTERNAL MODULE: ./node_modules/@amplitude/analytics-browser/lib/esm/index.js + 164 modules
var esm = __webpack_require__(38367);
// EXTERNAL MODULE: ./common/utils/chart.ts
var chart = __webpack_require__(10993);
;// CONCATENATED MODULE: ./components/modules/TimelinePage/index.tsx



























var TimelinePageContext = /*#__PURE__*/ (0,react.createContext)(null);
function TimelinePage() {
    var ref;
    var isMobile = (0,utils/* useMediaQuery */.ac)("(max-width: 767px)");
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var isAuthInit = (0,global/* default */.Z)(function(state) {
        return state.isAuthInit;
    });
    var ref1 = (0,react.useState)(chart/* SymbolTabsName.VoteResult */.sN.VoteResult), voteTabId = ref1[0], setVoteTabId = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,timeline/* default */.ZP)(function(state) {
        return [
            state.currentTimelineTab,
            state.setCurrentTimelineTab, 
        ];
    }), 2), currentTimelineTab = ref2[0], setCurrentTimelineTab = ref2[1];
    var scrollToTop = function() {
        window.scrollTo(0, 0);
    };
    var mounted = (0,useDidMount/* useMountedDelay */._)();
    var randomBannerCodes = (0,react.useMemo)(function() {
        return [
            service_user/* MissionCode.InvastCreateAccount */.Vk.InvastCreateAccount,
            service_user/* MissionCode.IGCreateAccount */.Vk.IGCreateAccount,
            service_user/* MissionCode.MooMooCreateAccount */.Vk.MooMooCreateAccount,
            service_user/* MissionCode.MonexCreateAccount */.Vk.MonexCreateAccount,
            banner/* BannerCode.Izanavi */.m.Izanavi,
            banner/* BannerCode.TakatradeOpening */.m.TakatradeOpening, 
        ].map(function(value) {
            return {
                value: value,
                sort: Math.random()
            };
        }).sort(function(a, b) {
            return a.sort - b.sort;
        }).map(function(param) {
            var value = param.value;
            return value;
        });
    }, []);
    var topBanner = (0,react.useMemo)(function() {
        if (voteTabId === chart/* SymbolTabsName.ScoringModel */.sN.ScoringModel) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RandomBanner/* default */.Z, {
                className: (TimelinePage_module_default()).banner,
                codes: [
                    banner/* BannerCode.Izanavi */.m.Izanavi
                ],
                isSupportRandom: false,
                fallbackCodes: [
                    service_user/* MissionCode.InvastCreateAccount */.Vk.InvastCreateAccount,
                    service_user/* MissionCode.IGCreateAccount */.Vk.IGCreateAccount,
                    service_user/* MissionCode.MooMooCreateAccount */.Vk.MooMooCreateAccount,
                    service_user/* MissionCode.MonexCreateAccount */.Vk.MonexCreateAccount,
                    banner/* BannerCode.Izanavi */.m.Izanavi,
                    banner/* BannerCode.TakatradeOpening */.m.TakatradeOpening, 
                ],
                fallbackElement: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (TimelinePage_module_default()).banner,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimeAlarmBanner/* default */.Z, {})
                })
            }, chart/* SymbolTabsName.ScoringModel */.sN.ScoringModel);
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RandomBanner/* default */.Z, {
            className: (TimelinePage_module_default()).banner,
            codes: randomBannerCodes,
            isSupportRandom: false,
            fallbackCodes: [
                service_user/* MissionCode.InvastCreateAccount */.Vk.InvastCreateAccount,
                service_user/* MissionCode.IGCreateAccount */.Vk.IGCreateAccount,
                service_user/* MissionCode.MooMooCreateAccount */.Vk.MooMooCreateAccount,
                service_user/* MissionCode.MonexCreateAccount */.Vk.MonexCreateAccount,
                banner/* BannerCode.Izanavi */.m.Izanavi,
                banner/* BannerCode.TakatradeOpening */.m.TakatradeOpening, 
            ],
            fallbackElement: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TimelinePage_module_default()).banner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimeAlarmBanner/* default */.Z, {})
            })
        });
    }, [
        voteTabId,
        randomBannerCodes
    ]);
    var getNextPageParamLivePosts = (0,react.useCallback)(function(lastPage, pages) {
        var ref;
        var posts = lastPage === null || lastPage === void 0 ? void 0 : (ref = lastPage.data) === null || ref === void 0 ? void 0 : ref.posts;
        if (posts && posts.length > 0) {
            return pages.length + 1;
        }
    }, []);
    var getNextPageParamPaidPosts = (0,react.useCallback)(function(lastPage) {
        var ref, ref1;
        var posts = lastPage === null || lastPage === void 0 ? void 0 : (ref = lastPage.data) === null || ref === void 0 ? void 0 : ref.posts;
        if (posts && posts.length > 0 && (lastPage === null || lastPage === void 0 ? void 0 : (ref1 = lastPage.data) === null || ref1 === void 0 ? void 0 : ref1.next_key)) {
            var ref2;
            return lastPage === null || lastPage === void 0 ? void 0 : (ref2 = lastPage.data) === null || ref2 === void 0 ? void 0 : ref2.next_key;
        }
    }, []);
    var handleChooseTab = function(tab) {
        if (currentTimelineTab === tab) return;
        (0,esm/* track */.j)("Click Tab At Home", {
            tab_name: tab
        });
        setCurrentTimelineTab(tab);
        setTimeout(scrollToTop, 0);
    };
    var ref3 = (0,es.useQuery)("getTimelinePageInitialData", (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, response, trendingPosts, domains, symbolId, liveUsers, investmentLevels;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return getInitTimelineData();
                case 3:
                    response = _ctx.sent;
                    trendingPosts = (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.sections) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[1]) === null || ref2 === void 0 ? void 0 : ref2.trending_posts) || [];
                    domains = ((response === null || response === void 0 ? void 0 : (ref3 = response.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.sections) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[2]) === null || ref5 === void 0 ? void 0 : ref5.domains) || []).reduce(function(acc, domain, index) {
                        if (domain.id !== 0) {
                            acc.push(domain);
                        }
                        if (index === 2) {
                            acc.push({
                                id: -1,
                                name: timeline/* INVESTMENT_TAB_NAME */.cj
                            });
                        }
                        return acc;
                    }, []);
                    symbolId = (response === null || response === void 0 ? void 0 : (ref6 = response.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.sections) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[3]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.symbol) === null || ref9 === void 0 ? void 0 : ref9.id) || null;
                    liveUsers = (response === null || response === void 0 ? void 0 : (ref10 = response.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.sections) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[4]) === null || ref12 === void 0 ? void 0 : ref12.on_stream_users) || [];
                    investmentLevels = (response === null || response === void 0 ? void 0 : (ref13 = response.data) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.sections) === null || ref14 === void 0 ? void 0 : (ref15 = ref14[5]) === null || ref15 === void 0 ? void 0 : ref15.feed_investment_levels) || [];
                    return _ctx.abrupt("return", {
                        posts: trendingPosts,
                        domains: domains,
                        symbolId: symbolId,
                        liveUsers: liveUsers,
                        investmentLevels: investmentLevels
                    });
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        enabled: isAuthInit && mounted,
        refetchOnWindowFocus: false,
        staleTime: 15 * 60 * 1000,
        cacheTime: 15 * 60 * 1000
    }), timelinePageInitialData = ref3.data, isFetchedTimeline = ref3.isFetched;
    var symbolId = (timelinePageInitialData === null || timelinePageInitialData === void 0 ? void 0 : timelinePageInitialData.symbolId) || null;
    var tabContent = (0,react.useMemo)(function() {
        if (currentTimelineTab === timeline/* TimelinePageTabs.Recommended */.j_.Recommended) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TimelinePage_module_default()).tabsContent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelinePage_RecommendTabSection, {
                    voteTabId: voteTabId,
                    setVoteTabId: setVoteTabId
                })
            });
        }
        if (currentTimelineTab === timeline/* TimelinePageTabs.LivePosts */.j_.LivePosts) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TimelinePage_module_default()).tabsContent,
                children: [
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (TimelinePage_module_default()).createPost,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreatePostBox/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (TimelinePage_module_default()).postsList,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineSection/* default */.Z, {
                            apiUrl: "/feeds/lives",
                            queryKey: [
                                api/* PostParentKey.LiveTopics */.rO.LiveTopics
                            ],
                            queryParamKey: "page",
                            getNextPageParam: getNextPageParamLivePosts,
                            defaultPageParam: 1
                        })
                    })
                ]
            });
        }
        if (currentTimelineTab === timeline/* TimelinePageTabs.PrimeRegistration */.j_.PrimeRegistration) {
            var ref;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TimelinePage_module_default()).tabsContent,
                children: [
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (TimelinePage_module_default()).createPost,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreatePostBox/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (TimelinePage_module_default()).postsList,
                        children: (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineSection/* default */.Z, {
                            apiUrl: "/feeds/paid",
                            noResultMessage: "現在プライム登録中のクリエイターはいません。<br/>お気に入りのクリエイターを見つけて、プライム登録してみましょう！",
                            queryKey: [
                                api/* PostParentKey.PaidPosts */.rO.PaidPosts,
                                currentUser === null || currentUser === void 0 ? void 0 : (ref = currentUser.id) === null || ref === void 0 ? void 0 : ref.toString(), 
                            ],
                            getNextPageParam: getNextPageParamPaidPosts,
                            queryParamKey: "next_key",
                            defaultPageParam: ""
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TimelinePage_module_default()).noPost,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                    name: "empty",
                                    width: 96,
                                    height: 96
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: "現在プライム登録中のクリエイターはいません。<br/>お気に入りのクリエイターを見つけて、プライム登録してみましょう！"
                                    }
                                })
                            ]
                        })
                    })
                ]
            });
        }
        if (currentTimelineTab === timeline/* TimelinePageTabs.PostTopics */.j_.PostTopics) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TimelinePage_module_default()).tabsContent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelinePage_PostTopicsTabSection, {})
            });
        }
    }, [
        currentTimelineTab,
        currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
        getNextPageParamLivePosts,
        getNextPageParamPaidPosts,
        isMobile,
        voteTabId, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelinePageContext.Provider, {
        value: {
            postTopics: (timelinePageInitialData === null || timelinePageInitialData === void 0 ? void 0 : timelinePageInitialData.domains) || [],
            isFetchedTimeline: isFetchedTimeline,
            trendingPosts: (timelinePageInitialData === null || timelinePageInitialData === void 0 ? void 0 : timelinePageInitialData.posts) || [],
            investmentLevels: (timelinePageInitialData === null || timelinePageInitialData === void 0 ? void 0 : timelinePageInitialData.investmentLevels) || [],
            liveUsers: (timelinePageInitialData === null || timelinePageInitialData === void 0 ? void 0 : timelinePageInitialData.liveUsers) || [],
            symbolId: symbolId
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (TimelinePage_module_default()).timelinePage,
            children: [
                currentUser && topBanner,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ImportantMessagesSection, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TimelinePage_module_default()).tabsGroup,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TimelinePage_module_default()).tabsHeader,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((TimelinePage_module_default()).tab, (0,_define_property/* default */.Z)({}, (TimelinePage_module_default()).active, currentTimelineTab === timeline/* TimelinePageTabs.Recommended */.j_.Recommended)),
                                    onClick: function() {
                                        handleChooseTab(timeline/* TimelinePageTabs.Recommended */.j_.Recommended);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (TimelinePage_module_default()).tabName,
                                        children: "おすすめ"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((TimelinePage_module_default()).tab, (0,_define_property/* default */.Z)({}, (TimelinePage_module_default()).active, currentTimelineTab === timeline/* TimelinePageTabs.LivePosts */.j_.LivePosts)),
                                    onClick: function() {
                                        handleChooseTab(timeline/* TimelinePageTabs.LivePosts */.j_.LivePosts);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (TimelinePage_module_default()).tabName,
                                        children: [
                                            (timelinePageInitialData === null || timelinePageInitialData === void 0 ? void 0 : (ref = timelinePageInitialData.liveUsers) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (TimelinePage_module_default()).liveIcon,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* LiveIcon */.xP, {
                                                    width: 20,
                                                    height: 20,
                                                    stokeWidth: 1.5
                                                })
                                            }),
                                            "LIVE"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((TimelinePage_module_default()).tab, (0,_define_property/* default */.Z)({}, (TimelinePage_module_default()).active, currentTimelineTab === timeline/* TimelinePageTabs.PrimeRegistration */.j_.PrimeRegistration)),
                                    onClick: function() {
                                        handleChooseTab(timeline/* TimelinePageTabs.PrimeRegistration */.j_.PrimeRegistration);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (TimelinePage_module_default()).tabName,
                                        children: "プライム投稿"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((TimelinePage_module_default()).tab, (0,_define_property/* default */.Z)({}, (TimelinePage_module_default()).active, currentTimelineTab === timeline/* TimelinePageTabs.PostTopics */.j_.PostTopics)),
                                    onClick: function() {
                                        var ref;
                                        if ((timelinePageInitialData === null || timelinePageInitialData === void 0 ? void 0 : (ref = timelinePageInitialData.domains) === null || ref === void 0 ? void 0 : ref.length) === 0) return;
                                        handleChooseTab(timeline/* TimelinePageTabs.PostTopics */.j_.PostTopics);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (TimelinePage_module_default()).tabName,
                                        children: "トピック"
                                    })
                                })
                            ]
                        }),
                        tabContent
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./config/env.ts
var env = __webpack_require__(36514);
;// CONCATENATED MODULE: ./pages/index.tsx





var title = "PostPrime | 高橋ダン企画-資産形成が学べる投資・株式予想・情報サイト";
var description = "PostPrimeは、高橋ダンがウォール街の経験をもとに企画した投資を実践するための学習サイトです。独自のチャート機能を使用し、資産をつくる手助けをします。";
var __N_SSP = true;
function HomeTimeline() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:url",
                        content: env/* SITE_BASE_URL */.B
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: env/* SITE_BASE_URL */.B
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "url",
                        content: "postprime.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }, "ogtype"),
                    (0,utils/* isProduction */.MF)() && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "facebook-domain-verification",
                        content: "bnygafzopgiu9k82kticxuoat5t6lz"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelinePage, {})
        ]
    });
};


/***/ }),

/***/ 42814:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"TopicSection_container__mfZOG","loading":"TopicSection_loading__v1Lxs","noPost":"TopicSection_noPost__WWUB5","titleWrapper":"TopicSection_titleWrapper__Nmt6_","keyword":"TopicSection_keyword__cZCwx","sortSection":"TopicSection_sortSection__GwL4x","linkBtn":"TopicSection_linkBtn__LPy1R","active":"TopicSection_active__hOF9d","post":"TopicSection_post__c5ow_"};

/***/ }),

/***/ 53811:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"selectEmotionMenu":"EmotionSelector_selectEmotionMenu__RE_AQ","emotions":"EmotionSelector_emotions__ndOUk","emotion":"EmotionSelector_emotion__9EnZC","active":"EmotionSelector_active__xMaek","highlight":"EmotionSelector_highlight__zSKCW","delEmotionBtn":"EmotionSelector_delEmotionBtn__YEzqX"};

/***/ }),

/***/ 55812:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"messages":"ImportantMessagesSection_messages__HJ0gH","message":"ImportantMessagesSection_message__krIxy","close":"ImportantMessagesSection_close__UCu9D","content":"ImportantMessagesSection_content__l2oqZ","info":"ImportantMessagesSection_info__ANGlY","warn":"ImportantMessagesSection_warn__VCwb7","error":"ImportantMessagesSection_error__EYhE5"};

/***/ }),

/***/ 10842:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"PopperWrapper_container__g49E_","arrow":"PopperWrapper_arrow__pe_hB"};

/***/ }),

/***/ 28739:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"homeRecommendCreatorsList":"HomeRecommendCreatorsList_homeRecommendCreatorsList__AlsO8","title":"HomeRecommendCreatorsList_title__3F30d","creatorsList":"HomeRecommendCreatorsList_creatorsList__QfqwZ","creatorItem":"HomeRecommendCreatorsList_creatorItem__d867B","followBtn":"HomeRecommendCreatorsList_followBtn__n0Qvf","readMoreBtn":"HomeRecommendCreatorsList_readMoreBtn__rPA_Z","creatorInfoWrapper":"HomeRecommendCreatorsList_creatorInfoWrapper__I2rGH","creatorAvatar":"HomeRecommendCreatorsList_creatorAvatar__QvbJk","creatorInfo":"HomeRecommendCreatorsList_creatorInfo__4irJ2","userNameWrapper":"HomeRecommendCreatorsList_userNameWrapper__8yAwS","userName":"HomeRecommendCreatorsList_userName__pO0mW","badge":"HomeRecommendCreatorsList_badge__zaB84","userBio":"HomeRecommendCreatorsList_userBio__HXrR4"};

/***/ }),

/***/ 82779:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"investmentLevelsTabSection":"InvestmentLevelsTabSection_investmentLevelsTabSection__VLWVq","postsList":"InvestmentLevelsTabSection_postsList__fvpQg","sectionHeader":"InvestmentLevelsTabSection_sectionHeader__lU_8X","title":"InvestmentLevelsTabSection_title__QV_L5","investmentLevelsList":"InvestmentLevelsTabSection_investmentLevelsList__gk3AW","investmentLevel":"InvestmentLevelsTabSection_investmentLevel__nZJva","active":"InvestmentLevelsTabSection_active__3AFH3"};

/***/ }),

/***/ 61758:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"postTopicsTabSection":"PostTopicsTabSection_postTopicsTabSection__oqitT","createPost":"PostTopicsTabSection_createPost__rWOrG","postsTopicList":"PostTopicsTabSection_postsTopicList__rPRX5","topicsListWrapper":"PostTopicsTabSection_topicsListWrapper__k_qeO","backBtn":"PostTopicsTabSection_backBtn__HzMvo","nextBtn":"PostTopicsTabSection_nextBtn__bQiSm","topicsList":"PostTopicsTabSection_topicsList__P_khs","topic":"PostTopicsTabSection_topic__ViPg6","active":"PostTopicsTabSection_active__zM_qg"};

/***/ }),

/***/ 79099:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"recommendTabSection":"RecommendTabSection_recommendTabSection__WvGfC","createPost":"RecommendTabSection_createPost__MCiIG","postsList":"RecommendTabSection_postsList__SqTmE","topicsListWrapper":"RecommendTabSection_topicsListWrapper__MVgP3","backBtn":"RecommendTabSection_backBtn__vt8du","nextBtn":"RecommendTabSection_nextBtn__fjjfq","topicsList":"RecommendTabSection_topicsList__o2oGv","topic":"RecommendTabSection_topic__OfIi2","active":"RecommendTabSection_active__HONB1"};

/***/ }),

/***/ 32634:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"SubscribingSection_sectionWrapper__Vc5rE","sectionTitleWrapper":"SubscribingSection_sectionTitleWrapper__4haxu","sectionTitle":"SubscribingSection_sectionTitle__eOB0K"};

/***/ }),

/***/ 20864:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"timelinePage":"TimelinePage_timelinePage__f0YD3","banner":"TimelinePage_banner__xSDnx","postsList":"TimelinePage_postsList__kPmKb","createPost":"TimelinePage_createPost__2t6vx","noPost":"TimelinePage_noPost__ngtSt","tabsGroup":"TimelinePage_tabsGroup__Qtv3B","tabsHeader":"TimelinePage_tabsHeader__7RwsJ","tab":"TimelinePage_tab__soTlp","tabName":"TimelinePage_tabName__deIBd","active":"TimelinePage_active__KCgCX","tabsContent":"TimelinePage_tabsContent__6ijp4","liveIcon":"TimelinePage_liveIcon__Ka5DV"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6007,6310,9122,4850,5489,4872,453,7393,3962,1618,2424,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);